<script setup lang="ts">
import { dashboardMetrics, industryStats, todoItems } from '@/mock/data'
import MetricCard from '@/components/MetricCard.vue'
import { showImproving } from '@/composables/useImprovingNotice'
</script>

<template>
  <section class="workbench-page">
    <div class="hero-panel">
      <div>
        <span class="eyebrow">今日服务概览 · 全部为模拟数据</span>
        <h1>让每一次训后服务都有回应、有记录、有结果</h1>
        <p>当前为前端原型演示。您可以切换角色视角、打开二级菜单并体验主要交互。</p>
      </div>
      <div class="hero-actions">
        <el-button type="primary" size="large" @click="showImproving">新建服务需求</el-button>
        <el-button size="large" @click="showImproving">查看服务台账</el-button>
      </div>
    </div>

    <div class="metric-grid"><MetricCard v-for="item in dashboardMetrics" :key="item.label" :item="item" /></div>

    <div class="dashboard-grid">
      <el-card shadow="never" class="panel-card">
        <template #header><div class="panel-title"><div><strong>我的待办</strong><span>按优先级实时整理</span></div><el-button link type="primary" @click="showImproving">查看全部</el-button></div></template>
        <div class="todo-list">
          <button v-for="item in todoItems" :key="item.title" class="todo-row" @click="showImproving">
            <span class="todo-dot" :class="item.level"></span>
            <span><strong>{{ item.title }}</strong><small>{{ item.meta }}</small></span>
            <el-tag size="small" effect="plain">{{ item.level }}</el-tag>
          </button>
        </div>
      </el-card>
      <el-card shadow="never" class="panel-card chart-card">
        <template #header><div class="panel-title"><div><strong>近八周服务趋势</strong><span>示例服务完成量</span></div><el-select model-value="全区" size="small" style="width:100px"><el-option label="全区" value="全区"/></el-select></div></template>
        <div class="bar-chart"><div v-for="(value,index) in industryStats" :key="index" class="bar-wrap"><div class="bar" :style="{height:`${value}%`}"></div><small>W{{ index+1 }}</small></div></div>
      </el-card>
    </div>
  </section>
</template>
